/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Only_Networks_With_History_LabelInputs */

const fr_settings_only_networks_with_history_label = /** @type {(inputs: Settings_Only_Networks_With_History_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réseaux à afficher`)
};

const en_settings_only_networks_with_history_label = /** @type {(inputs: Settings_Only_Networks_With_History_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Networks to show`)
};

/**
* | output |
* | --- |
* | "Networks to show" |
*
* @param {Settings_Only_Networks_With_History_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_only_networks_with_history_label = /** @type {((inputs?: Settings_Only_Networks_With_History_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Only_Networks_With_History_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_only_networks_with_history_label(inputs)
	return en_settings_only_networks_with_history_label(inputs)
});